<div
  [ngClass]="{
    past: startMissed,
    upcoming: isLessThanTwoHoursAway,
    ongoing: event.is_started,
  }"
  class="event-column d-flex align-items-start my-2 cursor-pointer card-container position-relative"
  [id]="event.event_id"
  [class.visited]="isLastVisited"
>
  <img
    [src]="event.event_json?.location_logo || 'assets/svg/event-default.svg'"
    class="event-image order-1"
    alt=""
  />
  <div class="order-2 event-container w-100">
    <div class="event-title d-flex flex-column">
      <div
        class="d-flex justify-content-between align-items-center event-main-title"
      >
        <span class="text-truncate" [title]="event.event_name">{{
          event.event_name
        }}</span>
      </div>
      <span class="fs-12 font-weight-light">
        @if (!event.end_datetime && !event.is_started) {
          Game Starts in
        }
        <ng-content></ng-content>
        @if (event.end_datetime || event.is_started) {
          Time Elapsed
        }
      </span>
    </div>
    <div class="event-body d-flex flex-wrap justify-content-start">
      <div class="icons d-flex flex-column justify-content-between">
        <div class="d-flex flex-wrap justify-content-between">
          <div class="d-flex fs-14 col-lg-12 col-xl-6 px-0">
            <div class="icon icon-calendar mr-2"></div>
            {{ event.start_datetime | date: dateFormat }}
          </div>
          <div class="d-flex fs-14 col-lg-12 col-xl-6 px-0">
            <div class="icon icon-clock mr-2"></div>
            {{ event.start_datetime | date: "h:mm a" }}
          </div>
        </div>
        @if (eventType !== eventColumnTypes.completed) {
          <div class="d-flex flex-wrap justify-content-between">
            <div class="d-flex fs-14 col-lg-12 col-xl-6 px-0">
              <mat-icon color="primary" class="host-name-icon">person</mat-icon>
              <div class="host-name text-truncate" [title]="event.host_name">
                {{ event.host_name }}
              </div>
            </div>
            @if (event.game_code) {
              <div class="d-flex fs-14 col-lg-12 col-xl-6 px-0">
                <div class="icon id mr-2 icon-game-code"></div>
                {{ event.game_code }}
              </div>
            }
          </div>
        } @else {
          <div class="d-flex flex-wrap justify-content-between">
            <div class="d-flex stat col-lg-6 px-0 flex-wrap">
              <mat-icon color="primary" class="host-name-icon">person</mat-icon>
              <div
                class="stat-count text-truncate"
                [title]="event.player_count"
              >
                {{ event.player_count || 0 }}
              </div>
            </div>
            <div class="d-flex stat col-lg-6 px-0 flex-wrap">
              <mat-icon svgIcon="app_numbers" class="mr-2"></mat-icon>
              <div class="stat-count text-truncate" [title]="event.team_count">
                {{ event.team_count || 0 }}
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <mat-icon class="order-3 cursor-pointer position-absolute mt-5 right-navigate"
    >navigate_next</mat-icon
  >
</div>
